import React, { useState, useEffect } from "react";
import { useAppSelector } from "../../../context-store";
import IdNameModel from "../../../models/common/IdNameModel";
import { useForm } from "react-hook-form";
import InterviewerService from '../../../services/interviewer/interviewer-service';
import toasterUtils from "../../../utils/toaster-utils";
import InterviewerProfileModel from "../../../models/interviewer/request/InterviewerProfileModel";
import MasterDataService from '../../../services/master-data-service';
import InterviewerProfileGridComponent from './InterviewerProfileGridComponent';
import { GeneralPoupConfig, ModalSize } from "../../../models/modal-types";
import modalUtils from "../../../utils/modal-utils";
import InterviewerProfilePopUp from "./InterviewerProfilePopUpComponent";
import loaderUtils from "../../../utils/loader-utils";
import { GuidEnum } from "../../../models/enums/GuidEnum";

const InterviewerProfileComponent = () => {
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const [primarySkillList, setPrimarySkillList] = useState<IdNameModel[]>([]);
    const [interviewerProfile, setInterviewerProfile] = useState<InterviewerProfileModel[]>([]);
    const [refreshInterviewerProfile, setRefreshInterviewerProfile] = useState<number>(2);

    useEffect(() => {
        getPrimarySkill();
        if (loggedInUser) {
            getInterviewerProfile(loggedInUser.profileId);
        }
    }, []);

    const getInterviewerProfile = (interviewerId?: string) => {
        if (interviewerId) {
            setRefreshInterviewerProfile(2);
            modalUtils.showLoader();
            InterviewerService.getInterviewerProfile(interviewerId).then((res) => {
                modalUtils.closeModal();
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                setInterviewerProfile(res.data);
                setRefreshInterviewerProfile(refreshInterviewerProfile * 5);
            }).catch((error) => {
                modalUtils.closeModal();
                toasterUtils.showError(error);
            });
        }
    };

    const getPrimarySkill = () => {
        MasterDataService.loadPrimarySkills().then((res) => {
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setPrimarySkillList(res.items);
        }).catch((error) => {
            toasterUtils.showError("Erorr fetching Primary skills");
        });
    };

    const onProfileActionHandler = (obj: InterviewerProfileModel, actionType: string) => {
        if (actionType === "Edit") {
            modalUtils.showLoader();
            MasterDataService.loadSecondarySkills(obj.primarySkillId).then((res) => {
                modalUtils.closeModal();
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                const config: GeneralPoupConfig = {
                    title: "Profile Details",
                    content: (
                        <InterviewerProfilePopUp
                            objInterviewerProfile={obj}
                            primarySkillList={primarySkillList}
                            secondarySkillList={res.items}
                            actionType={actionType}
                            onCloseProfile={onCloseProfileHandler}
                            onProfileSaved={onProfileSaveHandler}
                        />
                    ),
                    size: ModalSize.XL,
                    // className: "model-min-height-500"
                };
                modalUtils.showPopup(config);
            }).catch((error) => {
                modalUtils.closeModal();
                toasterUtils.showError("Erorr fetching Primary skills");
            });
        } else {
            const config: GeneralPoupConfig = {
                title: "Profile Details",
                content: (
                    <InterviewerProfilePopUp
                        objInterviewerProfile={obj}
                        primarySkillList={primarySkillList}
                        secondarySkillList={[]}
                        actionType={actionType}
                        onCloseProfile={onCloseProfileHandler}
                        onProfileSaved={onProfileSaveHandler}
                    />
                ),
                size: ModalSize.XL,
                className: "model-min-height-500"
            };
            modalUtils.showPopup(config);
        }
    };

    const onProfileSaveHandler = (formData: InterviewerProfileModel) => {
        modalUtils.showLoader();
        InterviewerService.saveInterviewerProfile(formData).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            toasterUtils.showSuccess(res.informationMessages.toString());
            if (loggedInUser) {
                getInterviewerProfile(loggedInUser.profileId);
            }
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    }

    const onCloseProfileHandler = () => {
        modalUtils.closeModal();
        if (loggedInUser) {
            getInterviewerProfile(loggedInUser.profileId);
        }
    };

    const addProfile = () => {
        let newProfileModel: InterviewerProfileModel = {
            interviewerId: loggedInUser?.profileId || "",
            interviewerProfileId: GuidEnum.Empty,
            profileName: "",
            primarySkillId: 0,
            primarySkillName: "",
            additionalSkills: "",
            interviewerSkills: []
        }
        onProfileActionHandler(newProfileModel, "Add");
    };

    return (
        <div className="card card-white">
            <div className="card-head card-head-text-right">
                <a className="btn-grid-add-action" title="Reload Data" onClick={() => getInterviewerProfile(loggedInUser?.profileId)}>
                    <i className="fa fa-refresh"></i>
                </a>
                <a className="btn-grid-add-action" onClick={addProfile}> + Add Profile</a>
            </div>
            <div className="card-body">
                {interviewerProfile.length > 0 && refreshInterviewerProfile > 2 &&
                    <InterviewerProfileGridComponent
                        key={refreshInterviewerProfile}
                        profilesList={interviewerProfile}
                        onProfileAction={onProfileActionHandler} />
                }
            </div>
        </div>
    );
};
export default InterviewerProfileComponent;